/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function (Flits) {
  /* To load js in all pages */
  if (
    Flits.Metafields.IS_SOCIAL_LOGIN_PAID &&
    Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE
  ) {
    if (window.flitsObjects.allCssJs.socialLoginJs) {
      Flits.LoadStyleScript(
        'socialLoginJs',
        window.flitsObjects.allCssJs.socialLoginJs.url
      );
    }
  }
  Flits(document).on('Flits:AccountPage:Loaded', function (event) {
    setInterval(function () {
      var data = event.detail;
      Flits.shopCountryName = 'Cyprus';
    }, 1000);
  });
  Flits(document).on('Flits:Navigation:Loaded', function (e) {
    let settings = e.detail.settings;
    let icons = {
      '#profile': `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="18" cy="18" r="18" fill="#EFF1F4"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M21.6544 13.9751C21.6544 16.0097 20.0048 17.6582 17.9713 17.6582C15.9367 17.6582 14.2871 16.0097 14.2871 13.9751C14.2871 11.9405 15.9367 10.292 17.9713 10.292C20.0048 10.292 21.6544 11.9405 21.6544 13.9751Z" stroke="black" stroke-width="1.3" stroke-linecap="square"/>
    <path d="M17.9999 20.3487C20.3866 20.3426 22.4591 21.3057 23.5008 23.3626C23.7607 23.8759 23.5271 24.4889 23.0053 24.7313C21.4967 25.4325 19.7956 25.7124 17.9999 25.708C16.2043 25.7124 14.5032 25.4325 12.9946 24.7314C12.4728 24.4889 12.2392 23.8759 12.4989 23.3625C13.5405 21.3036 15.6104 20.3425 17.9999 20.3487Z" stroke="black" stroke-width="1.3" stroke-linecap="square"/>
    </svg>`,
      '#address': `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="18" cy="18" r="18" fill="#EFF1F4"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M20.072 17.0052C20.072 15.8603 19.1443 14.9326 18.0003 14.9326C16.8554 14.9326 15.9277 15.8603 15.9277 17.0052C15.9277 18.1492 16.8554 19.0769 18.0003 19.0769C19.1443 19.0769 20.072 18.1492 20.072 17.0052Z" stroke="black" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M18.0001 25.7087C18.0001 25.7087 11.9369 21.7593 11.7841 16.8314C11.6769 13.3712 14.5667 10.2921 18.0001 10.2921C21.4336 10.2921 24.3226 13.3712 24.2169 16.8314C24.0633 21.8604 18.0001 25.7087 18.0001 25.7087Z" stroke="black" stroke-width="1.3" stroke-linecap="round"/>
    </svg>`,
      '#order': `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="18" cy="18" r="18" fill="#EFF1F4"/>
    <path d="M21.7279 13.5447C21.7279 11.6329 20.1781 10.083 18.2663 10.083C17.3457 10.0791 16.4615 10.4421 15.8091 11.0917C15.1567 11.7413 14.79 12.624 14.79 13.5447" stroke="black" stroke-width="1.3" stroke-linecap="square"/>
    <path d="M20.6409 17.1528H20.6042" stroke="black" stroke-width="1.3" stroke-linecap="square"/>
    <path d="M15.97 17.1528H15.9333" stroke="black" stroke-width="1.3" stroke-linecap="square"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M23.7757 13.7207C24.2163 13.7207 24.5808 14.0637 24.6075 14.5035L25.2468 25.0329C25.2758 25.5121 24.8951 25.9167 24.415 25.9167L11.5857 25.9167C11.1056 25.9167 10.7248 25.5121 10.7539 25.0329L11.3931 14.5035C11.4199 14.0637 11.7843 13.7207 12.2249 13.7207L23.7757 13.7207Z" stroke="black" stroke-width="1.3" stroke-linecap="round"/>
    </svg>`,
      '#wishlist': `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="18" cy="18" r="18" fill="#EFF1F4"/>
    <path d="M25.7086 16.0294C25.7003 13.9162 24.5916 11.9289 22.4058 11.2247C20.9049 10.7404 19.27 11.0097 18.0003 12.8326C16.7306 11.0097 15.0957 10.7404 13.5948 11.2247C11.4088 11.9289 10.3001 13.9167 10.2921 16.0302C10.2718 20.2333 14.5308 23.4495 17.9992 24.9868L18.0003 24.9863L18.0014 24.9868C21.47 23.4494 25.7293 20.2328 25.7086 16.0294Z" stroke="black" stroke-width="1.3" stroke-linecap="square"/>
    </svg>`,
      '#recentlyView': `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="18" cy="18" r="18" fill="#EFF1F4"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M20.6344 18.0442C20.6344 19.4992 19.4544 20.6783 17.9994 20.6783C16.5444 20.6783 15.3652 19.4992 15.3652 18.0442C15.3652 16.5883 16.5444 15.4092 17.9994 15.4092C19.4544 15.4092 20.6344 16.5883 20.6344 18.0442Z" stroke="black" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.9987 24.129C21.172 24.129 24.0745 21.8473 25.7087 18.044C24.0745 14.2407 21.172 11.959 17.9987 11.959H18.002C14.8287 11.959 11.9262 14.2407 10.292 18.044C11.9262 21.8473 14.8287 24.129 18.002 24.129H17.9987Z" stroke="black" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`,
      '#changePassword': `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20" r="20" fill="#EFF1F4"/>
    <rect x="12" y="17" width="16" height="12" rx="4" stroke="#1E2426" stroke-width="1.5"/>
    <path d="M20 24L20 22" stroke="#1E2426" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M24 17V15C24 12.7909 22.2091 11 20 11V11C17.7909 11 16 12.7909 16 15L16 17" stroke="#1E2426" stroke-width="1.5"/>
    </svg>`,
      '/account/logout': `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="18" cy="18" r="18" fill="#EFF1F4"/>
    <path d="M25.3083 17.9994L14.6602 17.9994" stroke="black" stroke-width="1.3" stroke-linecap="round"/>
    <path d="M23.1904 15.2705L25.9317 17.9996L23.1904 20.7297" stroke="black" stroke-width="1.3" stroke-linecap="round"/>
    <path d="M18.8379 21.8545L18.8379 24.8753C18.8379 25.3356 18.4648 25.7087 18.0046 25.7087L10.9013 25.7087C10.441 25.7087 10.0679 25.3356 10.0679 24.8753L10.0679 11.1253C10.0679 10.6651 10.441 10.292 10.9013 10.292L18.0046 10.292C18.4648 10.292 18.8379 10.6651 18.8379 11.1253L18.8379 14.1462" stroke="black" stroke-width="1.3" stroke-linecap="round"/>
    </svg>`
    };
    for (let i = 0; i < settings.navs.length; i++) {
      let icon = icons[settings.navs[i].url];
      if (icon != 'undefined') {
        settings.navs[i].icon = icon;
      }
    }
  });
  var ajaxWishlistViewFunction = function (xhrOrFetch) {
    var url = this._url;

    if (url.indexOf('collections') !== -1 || url.indexOf('/products') !== -1) {
      Flits.dispatchEvent('Flits:AjaxWishlist', {
        response: this,
        xhrOrFetch: xhrOrFetch
      });
    }
  };
  Flits.addAjaxEvents(ajaxWishlistViewFunction);
  Flits.addFetchEvents(ajaxWishlistViewFunction);

  Flits(document).on('Flits:AjaxWishlist', function () {
    setTimeout(function () {
      let collectionBtn = Flits('.flits-wishlist-colection');
      parseInt(Flits.wishlistButton.settings.isCountEnable) &&
        Flits(collectionBtn)
          .find('.flits-wls-count-btn')
          .css('display', 'flex'),
        Flits(collectionBtn).show(),
        Flits('.flits-wishlist-colection:not(.flits-template)')
          .parent()
          .attr('data-flits', 'wishlist-collection-parent');
    }, 1000);
    setTimeout(function () {
      Flits('.flits-wishlist-colection').each(function (index, ele) {
        let wishProdHandle = Flits(ele)
          .find('.flits-wls-button')
          .attr('data-flits-product-handle');
        if (Flits.isProductAddedInWishlist(wishProdHandle)) {
          Flits(ele)
            .find('.flits-wls-button')
            .removeClass('flits-wls-inactive');
          Flits(ele).find('.flits-wls-button').addClass('flits-wls-active');
          Flits(ele)
            .find('.flits-wls-button')
            .attr(
              'data-tippy-content',
              Flits.t(
                'Flits.locals.wishlisted_product_page.remove_from_wishlist_button',
                'Remove from Wishlist'
              )
            );
        }
      });
    }, 2000);
  });
  Flits(document).on('Flits:getShopifyProductData:complete', function (params) {
    let settings = params.detail;
    let item = settings.item;
    let response = settings.resp;
    let src = Flits(item).find('img').attr('src');
    let new_image = src.replace('_400x_crop_center', '');
    Flits(item).find('img').attr('src', new_image);
    Flits(item)
      .find('img')
      .after(`<img src="${response.product.images[1].src}" / alt="">`);
  });
  Flits(document).on('click', '.flits-view-product', function () {
    let url = Flits(this).parents('.flits-product-image').attr('src');
    window.history.pushState('obj', document.title, location.origin + url);
  });
  Flits(document).on(
    'click',
    '.flits-address-add-save-button',
    function (event) {
      let form = Flits(this).parents('form#address_form_new');
      if (
        Flits(form)
          .find('.flits-phone-with-country-div .flits-country-code-textbox')
          .val() === ''
      ) {
        Flits(form).find('.flits-country-drpdown').addClass('flits-red-border');
        Flits(form).find("[type='tel']").addClass('flits-red-border');
        setTimeout(function () {
          Flits(form)
            .find('.flits-country-drpdown')
            .removeClass('flits-red-border');
          Flits(form).find("[type='tel']").removeClass('flits-red-border');
        }, 2000);
        event.preventDefault();
        flitsSnackbar.show({
          text: Flits.t(
            'Flits.locals.address_page.select_country_code',
            'Please select the country code'
          ),
          pos: 'bottom-center',
          showAction: false,
          customClass: 'flits-alert-danger',
          duration: 2000
        });
      }
    }
  );
  Flits(document).on('click', '.flits-address-default-btn', function (event) {
    let btn = Flits(this);
    let add_detais = btn.closest('.flits-address-card');
    let phone = add_detais.attr('data-phone').trim();
    if (phone.length != 0 && phone.indexOf('+') == -1) {
      let form = Flits('form#address_form_new');
      Flits(form).find('.flits-country-drpdown').addClass('flits-red-border');
      Flits(form).find("[type='tel']").addClass('flits-red-border');
      setTimeout(function () {
        Flits(form)
          .find('.flits-country-drpdown')
          .removeClass('flits-red-border');
        Flits(form).find("[type='tel']").removeClass('flits-red-border');
      }, 2000);
      flitsSnackbar.show({
        text: Flits.t(
          'Flits.locals.address_page.select_country_code',
          'Please select the country code'
        ),
        pos: 'bottom-center',
        showAction: false,
        customClass: 'flits-alert-danger',
        duration: 2000
      });
      btn.parent().find('.flits-address-edit-btn').click();
    } else {
      return false;
    }

    Flits('form#address_form_new .flits-address-add-save-button').click();
  });
  Flits(document).on('Flits:wishlistButton:Loaded', function (event) {
    let data = event.detail.settings;
    data.addtocartSelectors = [
      "form[action='" +
        window.flits_add_to_cart_url +
        "']:not([id*='product-form-installment'])"
    ];
  });
})(Flits);
